/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_1_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To use your own spreadsheet, choose File → Open inside GridCraft and select a copy of an .xlsx workbook. The application opens the browser file picker. Keep the source file until you have checked the downloaded result. For more complex Excel files, follow the compatibility guide before editing important data.`)
};

const zh_gc_search_guides_gridcraft_online_sections_1_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果使用自己的电子表格，在 GridCraft 内选择 File → Open，并选取 .xlsx 工作簿的副本。应用会打开浏览器文件选择器。在验证下载结果之前，应保留源文件。对于复杂 Excel 文件，请先阅读兼容性指南。`)
};

/**
* | output |
* | --- |
* | "To use your own spreadsheet, choose File → Open inside GridCraft and select a copy of an .xlsx workbook. The application opens the browser file picker. Keep ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_1_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_1_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_1_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_1_paragraphs_0 as "gc.search_guides.gridcraft_online.sections.1.paragraphs.0" }